module.exports = __webpack_public_path__ + "media/images/homes/Cloud-based-61aab34ad7a3ab7ca4e7f1ee3f1d99ef.png";